import { DataType } from '@tencent/slide-sdk-model';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

// model - sdk对上层类型映射
export const ADD_ON_MODE_MAP = new Map([
    [DataType.Presentation, UIModelType.PRESENTATION],
    [DataType.Theme, UIModelType.THEME],
    [DataType.Section, UIModelType.SECTION],
    [DataType.SlideMaster, UIModelType.MASTER],
    [DataType.SlideLayout, UIModelType.LAYOUT],
    [DataType.Slide, UIModelType.SLIDE],
    [DataType.Notes, UIModelType.NOTE],
    [DataType.Timing, UIModelType.TIMING],
    [DataType.NotesMaster, UIModelType.NOTE],
    [DataType.GroupShape, UIModelType.GROUP],
    [DataType.Connector, UIModelType.CONNECTOR],
    [DataType.Picture, UIModelType.IMAGE],
    [DataType.GraphicalObjectFrameTable, UIModelType.TABLE],
    [DataType.GraphicalObjectFrameChart, UIModelType.CHART],
    [DataType.GraphicalObjectFrameSmartArt, UIModelType.SMART_ART],
    [DataType.Shape, UIModelType.SHAPE],
    [DataType.GraphicalObjectFrameUnknown, UIModelType.SHAPE],
]);
